<template>
    <Button
        severity="secondary"
        class="p-button-extra-sm"
        icon="pi pi-file-pdf"
        @click.prevent="loadPDf"
        text
        :loading="exporting"
        :title="$t('lang.report.pdf_dashboard')"
        label="PDF"
    />
</template>

<script>
    import Button from "primevue/button";
    import ReportApi from "../../api/ReportApi";
    import Alerts from "../../mixins/Alerts";
    import CsvExportJob from "../../mixins/CsvExportJob";

    export default {
        mixins: [Alerts, CsvExportJob],
        props: ['domain', 'base'],
        data() {
            return {
                exporting: false,
            };
        },
        methods: {
            /**
             * PDF рендерится в воркере и может занять минуты, поэтому индикатор остаётся
             * на кнопке: глобальный прелоадер всё это время держал бы страницу заблокированной.
             */
            async loadPDf() {
                this.exporting = true;

                try {
                    const response = await ReportApi.getDashboardReportsPdf({domain: this.domain, base: this.base});
                    await this.waitForCsvExport(response.job_id);
                } catch (error) {
                    this.alertError(error.message);
                } finally {
                    this.exporting = false;
                }
            }
        },
        components: {
            Button,
        }
    }
</script>

<style scoped>
.p-button {
    box-shadow: none !important;
}
</style>
